// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import gitVersion from '../environments/git-version';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import V1 from './pages/v1';
import V2 from './pages/v2';
import ReportsContent from './pages/Reports/ReportsContent';

// Log SCM/build metadata on client startup
console.log(JSON.stringify(gitVersion));

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <BrowserRouter>
    <div className="App">
      <Routes>
        <Route path="/" element={<Navigate to="/app/v1" replace />} />
        <Route path="/app" element={<Navigate to="/app/v1" replace />} />
        <Route path="/app/v1" element={<V1 />} />
        <Route path="/app/v2" element={<V2 />} />
        <Route path="/reports" element={<ReportsContent />} />
      </Routes>
    </div>
  </BrowserRouter>
);
